import {useKnowledgeConfiguration} from "./atom/knowledgeConfiguration";

function useEdit() {
  const { open } = useKnowledgeConfiguration();

  return [open] as const;
}

export default useEdit;
